import { defaultPersonBidragColumns } from "../../../../../config/person";
import useActiveColumns from "../../../../../hooks/useActiveColumns";
import { PersonDto } from "../../../../../interfaces/schema";
import IngenRegistreringer from "../IngenRegistreringer";
import TableBasic, { TableRow } from "../../../../Table/TableBasic";
import { TD, getHeaderActiveColumns } from "../../../../../util/table";
import { SortBy } from "../../../../../interfaces/table";
import useLocalStorageState from "use-local-storage-state";
import { orderBy } from "../../../../../util/orderBy";

const Bidragsfaktura = ({
  person,
  invalidateData,
}: {
  person: PersonDto;
  invalidateData: InvalidateDataFunction<any>;
}) => {
  const [sortBy, setSortBy] = useLocalStorageState<SortBy[]>(
    "personBidragsfakturaSortBy",
    {
      defaultValue: defaultSortBy,
    },
  );
  const [activeColumns, setActiveColumns] = useActiveColumns(
    "person-bidragsfaktura-active-columns",
    defaultPersonBidragColumns,
  );
  const { personBidragsopkraevning } = person;

  if (personBidragsopkraevning?.length === 0) {
    return <IngenRegistreringer invalidateData={invalidateData} />;
  }

  return (
    <TableBasic
      columns={activeColumns}
      defaultColumns={defaultPersonBidragColumns}
      setActiveColumns={setActiveColumns}
      invalidateData={invalidateData}
      headerRow={
        <>
          {getHeaderActiveColumns(activeColumns, {
            defaultSortBy,
            setSortBy,
            sortBy,
          })}
        </>
      }
    >
      {orderBy(
        personBidragsopkraevning,
        sortBy.map((ds) => ds.field),
        sortBy.map((ds) => ds.direction),
      ).map((bf) => {
        return (
          <TableRow key={bf.id}>
            <>
              {activeColumns
                .filter((col) => col.active)
                .map((col) => (
                  <TD key={col.field} col={col} rowData={bf} />
                ))}
            </>
          </TableRow>
        );
      })}
    </TableBasic>
  );
};

const defaultSortBy: SortBy[] = [
  {
    direction: "desc",
    field: "",
  },
];

export default Bidragsfaktura;
